/** How far in from each rounded end the meter's 0 and 100% sit, as a fraction of its radius: a small story still shows fill. */
export const METER_CORNER_FRACTION = 0.4;

/** Where a value (0 to 1) sits along a meter of this size, as a percentage of its width, the same mapping its fill uses. */
export function meterPercent(value: number, width: number, height: number) {
  const corner = ((height / 2) / width) * 100 * METER_CORNER_FRACTION;
  return corner + value * (100 - 2 * corner);
}
